module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section position-relative no-padding-top-bottom"
  }, [_c('div', {
    staticClass: "container is-fullwidth"
  }, [_c('div', {
    staticClass: "col lg-12 lg-no-padding-lr no-margin-bottom"
  }, [_c('div', {
    staticClass: "c-heroslider w-slider",
    attrs: {
      "data-delay": "3000",
      "data-animation": "fade",
      "data-autoplay": "1",
      "data-easing": "ease-out-expo",
      "data-duration": "900",
      "data-infinite": "1"
    }
  }, [_c('div', {
    staticClass: "c-heroslider_mask w-slider-mask"
  }, [_c('div', {
    staticClass: "c-heroslider__slide w-slide"
  }, [_c('div', {
    staticClass: "c-heroslider__content bg-image-1"
  }, [_c('div', {
    staticClass: "container is-wide"
  }, [_c('div', {
    staticClass: "col lg-9 md-12 position-relative"
  }, [_c('h2', {
    staticClass: "heading-alpha on-dark",
    staticStyle: {
      "font-size": "65px"
    }
  }, [_vm._v("Get More Value")]), _vm._v(" "), _c('div', {
    staticClass: "flexh-align-center xs-is-wrapping overflow-hidden"
  }, [_c('div', {
    staticClass: "c-heroslider__discount"
  }, [_vm._v("27%"), _c('br'), _vm._v("OFF")]), _vm._v(" "), _c('a', {
    staticClass: "button-primary animated is-white margin-left w-inline-block",
    attrs: {
      "data-w-id": "382fd6e7-7654-e195-4458-f597a99853b8",
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "button-primary-text",
    staticStyle: {
      "-webkit-transform": "translate3d(0, 0PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
      "-moz-transform": "translate3d(0, 0PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
      "-ms-transform": "translate3d(0, 0PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
      "transform": "translate3d(0, 0PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
      "opacity": "1"
    }
  }, [_vm._v("this season")]), _vm._v(" "), _c('div', {
    staticClass: "button-primary-text for-hover",
    staticStyle: {
      "opacity": "0",
      "display": "block",
      "-webkit-transform": "translate3d(0, 20PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
      "-moz-transform": "translate3d(0, 20PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
      "-ms-transform": "translate3d(0, 20PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
      "transform": "translate3d(0, 20PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
    }
  }, [_vm._v("let's go "), _c('span', {
    staticClass: "fa margin-left"
  }, [_vm._v("")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col lg-5"
  })]), _vm._v(" "), _c('img', {
    staticClass: "hero-slide-image alignself-center is-model",
    attrs: {
      "src": "/static/assets/images/shopping-bag1.png",
      "width": "530",
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden w-slider-arrow-left"
  }, [_c('div', {
    staticClass: "w-icon-slider-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "hidden w-slider-arrow-right"
  }, [_c('div', {
    staticClass: "w-icon-slider-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-heroslider__nav w-slider-nav w-round"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col block-centered text-align-center lg-6 md-12",
    staticStyle: {
      "margin-top": "-5em"
    }
  }, [_c('div', {
    staticClass: "low-text-contrast"
  }, [_vm._v("Where would you like to get your first service from us today?")])])]), _vm._v(" "), _c('div', {
    staticClass: "container position-relative is-wide"
  }, [_c('div', {
    staticClass: "col lg-12"
  }, [_c('div', {
    staticClass: "w-layout-grid c-grid2x4"
  }, [_c('a', {
    staticClass: "link-block w-inline-block",
    attrs: {
      "id": "w-node-7f9b90f86253-9399af97",
      "data-w-id": "19ccc1ed-fe9e-99e5-db47-7f9b90f86253",
      "href": "farmmarket"
    }
  }, [_c('div', {
    staticClass: "c-gridgallery1__content-2"
  }, [_c('div', {
    staticClass: "on-dark text-medium weight-is-medium size-h2"
  }, [_vm._v("Farmer's Market")]), _vm._v(" "), _c('div', {
    staticClass: "on-dark margin-bottom-double"
  }, [_vm._v("From the tiniest to the largest products we have got all  you...")]), _vm._v(" "), _c('div', {
    staticClass: "flexh-align-center"
  }, [_c('div', {
    staticClass: "on-dark margin-right-small text-small"
  }, [_vm._v("Check Out Market")]), _vm._v(" "), _c('div', {
    staticClass: "iconfont on-dark is-11px"
  }, [_c('em', {
    staticClass: "iconfont__no-italize"
  }, [_vm._v("")])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-gridgallery1__image img3"
  })]), _vm._v(" "), _c('a', {
    staticClass: "link-block w-inline-block",
    attrs: {
      "id": "w-node-7f9b90f8625e-9399af97",
      "data-w-id": "19ccc1ed-fe9e-99e5-db47-7f9b90f8625e",
      "href": "pjsupermarket"
    }
  }, [_c('div', {
    staticClass: "c-gridgallery1__content-2"
  }, [_c('div', {
    staticClass: "on-dark text-medium weight-is-medium size-h2"
  }, [_vm._v("P & J Supermarket")]), _vm._v(" "), _c('div', {
    staticClass: "on-dark margin-bottom-double"
  }, [_vm._v("From the tiniest to the largest products we have got all  you...")]), _vm._v(" "), _c('div', {
    staticClass: "flexh-align-center"
  }, [_c('div', {
    staticClass: "on-dark margin-right-small text-small"
  }, [_vm._v("View Store")]), _vm._v(" "), _c('div', {
    staticClass: "iconfont on-dark is-11px"
  }, [_c('em', {
    staticClass: "iconfont__no-italize"
  }, [_vm._v("")])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-gridgallery1__image img4"
  })]), _vm._v(" "), _c('a', {
    staticClass: "link-block w-inline-block",
    attrs: {
      "id": "w-node-7f9b90f86269-9399af97",
      "data-w-id": "19ccc1ed-fe9e-99e5-db47-7f9b90f86269",
      "href": "essencespa"
    }
  }, [_c('div', {
    staticClass: "c-gridgallery1__content-2"
  }, [_c('div', {
    staticClass: "on-dark text-medium weight-is-medium size-h2"
  }, [_vm._v("Essence Spa")]), _vm._v(" "), _c('div', {
    staticClass: "on-dark margin-bottom-double"
  }, [_vm._v("From the tiniest to the largest products we have got all  you...")]), _vm._v(" "), _c('div', {
    staticClass: "flexh-align-center"
  }, [_c('div', {
    staticClass: "on-dark margin-right-small text-small"
  }, [_vm._v("Pick a Schedule ")]), _vm._v(" "), _c('div', {
    staticClass: "iconfont on-dark is-11px"
  }, [_c('em', {
    staticClass: "iconfont__no-italize"
  }, [_vm._v("")])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-gridgallery1__image img6"
  })]), _vm._v(" "), _c('a', {
    staticClass: "link-block w-inline-block",
    attrs: {
      "id": "w-node-7f9b90f86274-9399af97",
      "data-w-id": "19ccc1ed-fe9e-99e5-db47-7f9b90f86274",
      "href": "chickenrepublic"
    }
  }, [_c('div', {
    staticClass: "c-gridgallery1__content-2"
  }, [_c('div', {
    staticClass: "on-dark text-medium weight-is-medium size-h2"
  }, [_vm._v("Chicken Republic")]), _vm._v(" "), _c('div', {
    staticClass: "margin-bottom-double on-dark"
  }, [_vm._v("From the tiniest to the largest products we have got all  you...")]), _vm._v(" "), _c('div', {
    staticClass: "flexh-align-center"
  }, [_c('div', {
    staticClass: "on-dark margin-right-small text-small"
  }, [_vm._v("Order now ")]), _vm._v(" "), _c('div', {
    staticClass: "iconfont on-dark is-11px"
  }, [_c('em', {
    staticClass: "iconfont__no-italize"
  }, [_vm._v("")])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-gridgallery1__image img5"
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section no-padding-top-bottom overflow-hidden"
  }, [_c('div', {
    staticClass: "container is-wide",
    staticStyle: {
      "background": "#000000"
    }
  }, [_c('div', {
    staticClass: "col lg-12 no-margin-bottom position-relative no-padding-lr overflow-hidden"
  }, [_c('img', {
    staticClass: "position-absolute cover-object",
    attrs: {
      "src": "/static/assets/images/showslive.jpg",
      "sizes": "(max-width: 991px) 100vw, 1400px",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container container-nested c-overlay-content"
  }, [_c('div', {
    staticClass: "col lg-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col lg-4 lg-md-sm-no-margin-bottom xs-12"
  }, [_c('div', {
    staticClass: "on-dark size-h1 margin-bottom-small"
  }, [_vm._v("Experience our Live Shows")]), _vm._v(" "), _c('div', {
    staticClass: "text-large margin-bottom on-dark"
  }, [_vm._v("This December")]), _vm._v(" "), _c('a', {
    staticClass: "button-primary animated is-white w-inline-block",
    attrs: {
      "data-w-id": "93d51ea5-d4cf-8611-f2da-228b237c60fb",
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "button-primary-text",
    staticStyle: {
      "-webkit-transform": "translate3d(0, 0PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
      "-moz-transform": "translate3d(0, 0PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
      "-ms-transform": "translate3d(0, 0PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
      "transform": "translate3d(0, 0PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
      "opacity": "1"
    }
  }, [_vm._v("find out more")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13e458f4"}!./src/pages/Home/template.html
// module id = 233
// module chunks = 0